/* Digital Rollup: Kopfzeile, Menü am Handy, weiches Scrollen und Anker-Links auf allen Seiten */
(() => {
  const head = document.querySelector('.dr-head');
  if (!head) return;
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const designMode = !!(window.Shopify && window.Shopify.designMode);
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  // Menü am Handy und Tablet
  const burger = head.querySelector('.dr-burger');
  const menu = document.getElementById('drMenu');
  const menuOpen = () => !!menu && !menu.hidden;
  const setMenu = (open) => {
    if (!burger || !menu) return;
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    menu.hidden = !open;
    head.classList.toggle('menu-open', open);
    if (open) head.classList.remove('away');
  };
  if (burger && menu) {
    burger.addEventListener('click', () => setMenu(!menuOpen()));
    menu.addEventListener('click', (e) => { if (e.target.closest('a')) setMenu(false); });
    document.addEventListener('click', (e) => { if (menuOpen() && !head.contains(e.target)) setMenu(false); });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && menuOpen()) { setMenu(false); burger.focus(); }
    });
    matchMedia('(min-width: 1101px)').addEventListener('change', (m) => { if (m.matches) setMenu(false); });
  }

  // Kopfzeile: Linie beim Scrollen, dunkel über der Bühne der Startseite,
  // beim Runterscrollen ausgeblendet, beim Hochscrollen wieder da
  const story = document.getElementById('start');
  let lastY = scrollY;
  const update = () => {
    const y = scrollY, storyBottom = story ? story.getBoundingClientRect().bottom : 0;
    head.classList.toggle('scrolled', y > 8);
    head.classList.toggle('on-dark', storyBottom > head.offsetHeight + 1);
    if (storyBottom > 0 || y < lastY - 6 || y < head.offsetHeight * 2 || menuOpen()) head.classList.remove('away');
    else if (y > lastY + 6) head.classList.add('away');
    lastY = y;
  };
  addEventListener('scroll', update, { passive: true });
  update();

  // Weiches Scrollen mit Mausrad und Touchpad, am Handy bleibt es nativ
  let lenis = null;
  if (!reduceMotion && !designMode && window.Lenis) {
    lenis = new Lenis({ lerp: 0.12 });
    window.lenis = lenis;
    const loop = (t) => { lenis.raf(t); requestAnimationFrame(loop); };
    requestAnimationFrame(loop);
  }

  // Anker-Links: Ist das Ziel auf dieser Seite, dorthin scrollen.
  // Fehlt es (z. B. „#faq“ auf einer Unterseite), zur Startseite mit diesem Anker wechseln.
  document.addEventListener('click', (e) => {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const a = e.target.closest('a[href*="#"]');
    if (!a || a.target === '_blank') return;
    const url = new URL(a.getAttribute('href'), location.href);
    if (url.origin !== location.origin || url.hash.length < 2) return;
    // Themen-Links zum Formular (#thema-…) übernimmt das Kontaktformular selbst: Thema wählen und hinscrollen
    // (auch beim zweiten Klick auf denselben Link, dann ändert sich die Adresse nicht)
    if (url.hash.startsWith('#thema-') && url.pathname === location.pathname && document.getElementById('kontaktformular')) {
      e.preventDefault();
      setMenu(false);
      if (location.hash === url.hash) window.dispatchEvent(new HashChangeEvent('hashchange'));
      else location.hash = url.hash;
      return;
    }
    let el = null;
    try { el = document.querySelector(decodeURIComponent(url.hash)); } catch (err) { return; }
    const samePage = url.pathname === location.pathname;
    // Logo auf der Startseite („#top“): immer ganz nach oben, nicht zum Element (das steckt in der festgehaltenen Bühne)
    if (url.hash === '#top' && samePage) {
      e.preventDefault();
      setMenu(false);
      if (lenis) lenis.scrollTo(0, { duration: 1.1 });
      else window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      return;
    }
    if (el && (samePage || url.pathname === root)) {
      e.preventDefault();
      setMenu(false);
      // gleicher Abstand wie beim Aufruf mit Anker (scroll-padding-top + scroll-margin-top aus dem CSS)
      const off = (parseFloat(getComputedStyle(document.documentElement).scrollPaddingTop) || 0)
        + (parseFloat(getComputedStyle(el).scrollMarginTop) || 0);
      if (lenis) lenis.scrollTo(el, { offset: -(off || 88), duration: 1.1 });
      else el.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth' });
    } else if (!el && samePage && location.pathname !== root) {
      e.preventDefault();
      location.href = root + url.hash;
    }
  });
})();
